import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['query', 'phoneErrorMessage'];

  checkPhoneNumber() {
    const phoneNumber = this.queryTarget.value.replace(/\s+/g, '');

    if (phoneNumber.length >= 5) {
      // make an api call to check if the phone number already exists
      // if it exits show an error message in errorMessageTarget
      fetch(`/admin/users/check_phone_number?phone=${encodeURIComponent(phoneNumber)}`)
        .then(response => response.json())
        .then(data => {
          if (data.exists) {
            // add class to errorMessageTarget
            this.phoneErrorMessageTarget.classList.add('alert', 'alert-danger');
            // insert link to the error message from data response
            if (data.user_id) {
              this.phoneErrorMessageTarget.innerHTML = `A user with this phone number already exists. <a href='/admin/users/${data.user_id}/edit'>View User</a>`;
            } else {
              this.phoneErrorMessageTarget.innerHTML = `Few users with this phone number already exist. <a href='/admin/users?q=${phoneNumber}'>View users</a>`;
            }
          } else {
            // remove class from errorMessageTarget
            this.phoneErrorMessageTarget.classList.remove('alert', 'alert-danger');
            this.phoneErrorMessageTarget.textContent = '';
          }
        })
        .catch(error => {
          this.phoneErrorMessageTarget.textContent = 'An error occurred while checking the phone number.';
        });
    }
  }
}
